// extracted by mini-css-extract-plugin
export default {"normal":"widgetCardDivider_normal__mCfSL","bold":"widgetCardDivider_bold__EMVrB"};